/* baitishk-pairs.js — Single-variant Add handler for Pairs Well With block.
   Multi-variant products use data-baitishk-trigger and are handled by the
   existing drawer code in baitishk-custom.js.
*/
(function () {
  'use strict';

  function refreshCartUI(cartDrawerHtml) {
    if (!cartDrawerHtml) return;

    /* Patch header cart badge */
    try {
      var temp = document.createElement('div');
      temp.innerHTML = cartDrawerHtml;
      var countSrc = temp.querySelector('.cart-count');
      var count = countSrc ? (countSrc.textContent || '').trim() : null;

      if (count !== null) {
        var n = parseInt(count, 10);
        if (isNaN(n)) n = (count === '~') ? 100 : 0;

        var cartIcon = document.getElementById('cart-icon-bubble');
        if (cartIcon) {
          cartIcon.querySelectorAll('.cart-count').forEach(function (el) { el.remove(); });
          var badge = document.createElement('div');
          if (n > 0) {
            badge.className = 'absolute inline-flex content-center cart-count rounded-50 bg-sale fs-10';
            var displayCount = n < 100 ? String(n) : '~';
            badge.innerHTML = '<span class="count">' + displayCount + '</span>' +
                              '<span class="visually-hidden">' + n + '</span>';
          } else {
            badge.className = 'hidden cart-count';
            badge.innerHTML = '<span aria-hidden="true">0</span>';
          }
          cartIcon.appendChild(badge);

          var actionParent = cartIcon.closest('.header__action');
          if (actionParent) {
            if (n === 0) actionParent.classList.add('header__action_cart_empty');
            else actionParent.classList.remove('header__action_cart_empty');
          }
        }
      }
    } catch (e) { /* noop */ }

    /* Replace cart-drawer DOM */
    try {
      var existing = document.querySelector('cart-drawer');
      if (existing) {
        var wrapTemp = document.createElement('div');
        wrapTemp.innerHTML = cartDrawerHtml.trim();
        var newEl = wrapTemp.querySelector('cart-drawer');
        if (newEl) existing.replaceWith(newEl);
      }
    } catch (e) { /* noop */ }
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-pairs-add-single]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    if (btn.disabled) return;

    var variantId = btn.dataset.variantId;
    if (!variantId) return;

    btn.disabled = true;
    var originalText = btn.textContent;
    btn.textContent = '…';

    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({
        id: Number(variantId),
        quantity: 1,
        sections: 'cart-drawer',
        sections_url: window.location.pathname
      })
    })
    .then(function (res) {
      if (!res.ok) return res.json().then(function (d) { throw new Error(d.description || 'Error'); });
      return res.json();
    })
    .then(function (data) {
      btn.classList.add('is-success');
      btn.textContent = '✓';

      var cartDrawerHtml = data && data.sections && data.sections['cart-drawer'];
      if (cartDrawerHtml) refreshCartUI(cartDrawerHtml);

      document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true }));

      setTimeout(function () {
        btn.classList.remove('is-success');
        btn.textContent = originalText;
        btn.disabled = false;
      }, 1500);
    })
    .catch(function (err) {
      console.warn('[Baitishk Pairs] Add failed:', err);
      btn.classList.add('is-error');
      btn.textContent = 'Error';
      setTimeout(function () {
        btn.classList.remove('is-error');
        btn.textContent = originalText;
        btn.disabled = false;
      }, 2000);
    });
  });
}());
